import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { travelXNewEffects } from 'src/app/travelxnew/store/effects/travelxnew.effects';
import { travelXNewReducers } from 'src/app/travelxnew/store/reducers';
import { travelXNewFeatureKey } from 'src/app/travelxnew/store/selectors';
import { EnvironmentProviders } from '@angular/core';

export const provideTravelXNewStore = (): EnvironmentProviders[] => [
    provideState(travelXNewFeatureKey, travelXNewReducers),
    provideEffects(travelXNewEffects)
];
